export type StringOrNumber = string | number

export type ProductProps = {
  spuId: string;
  spuCode: string;
  category: string;
  categoryId: string;
  name: string;
  rating: string | null;
  reviewCount: number;
  description: string;
  oneStar: number;
  twoStar: number,
  threeStar: number,
  fourStar: number,
  fiveStar: number,
  colorKeyValue?: { [key: string]: string },
  webTitle: string;
  webDescription: string;
  shopProductCategoryChains: {
    id: string;
    categoryName: string;
    categoryUrl: string;
  }[],
  newProduct?: boolean,
  status: string;
  shopProductItemDetailVos:
  // {
  //   // images: {
  //   //   whiteBackPic: string[];
  //   //   scenePic: string[];
  //   //   detailPic: string[];
  //   //   measurementPic: string[];
  //   // },
  //   // measurementDescription: string;
  //   // salePrice: number;
  //   // originPrice: number;
  //   // defaultShow: boolean;
  //   // saleAttribute: {
  //   //   color: string;
  //   //   size?: string;
  //   // };
  //   // discount?: number;
  //   // activeFlag: boolean;
  // }
  SKUProps[],
  installationInstructionAddress: {
    url: string;
    name: string;
  }[],
  installationFlag: string,
  warrantyFlag: string,
  warrantyYear?: number,
  warrantyRange?: string,
  productAttribute: {},
  skuUrl: {
    url: string;
    saleAttribute: { color: string;[key: string]: string; };
  }[]
}

export type SKUProps = {
  id: string,
  currency: string,
  itemCode: string;
  colorValue: string;
  itemId: string;
  images: {
    whiteBackPic: string[];
    scenePic: string[];
    detailPic: string[];
    measurementPic: string[];
  },
  measurementDescription: string;
  salePrice: number;
  originPrice: number;
  defaultShow: boolean;
  saleAttribute: {
    color: string;
    [key: string]: string;
  };
  discount?: number;
  activeFlag: boolean;
  stock: number;
  sendOutRange: number
  saleFlag: boolean;
}

export enum CardType {
  /** 公告 */
  NOTIFICATION = 'NOTIFICATION',
  /** 页头 */
  PAGE_HEADER = 'PAGE_HEADER',
  /** 幻灯片 */
  SLIDE_DESK = 'SLIDE_DESK',
  /** 商品集合 */
  PRODUCT_COLLECTION = 'PRODUCT_COLLECTION',
  /** 图文列表 */
  MEDIA_CARD_LIST = 'MEDIA_CARD_LIST',
  /** 最近浏览 */
  RECENT_VIEW = 'RECENT_VIEW',
  /** 图标文字 */
  ICON_TEXT = 'ICON_TEXT',
  /** 新人优惠 */
  NEW_CUSTOMER = 'NEW_CUSTOMER',
  /** tab切换图文列表 */
  TAB_MEDIA_CARD_LIST = 'TAB_MEDIA_CARD_LIST',
  /** 十张图片的图文列表 */
  MEDIA_CARD_LIST_THREE = 'MEDIA_CARD_LIST_THREE',
  /** 图片组件 */
  SINGLE_PICTURE = 'SINGLE_PICTURE',
  /** 主题文案 */
  THEME_TEXT = 'THEME_TEXT',
  /** 图文 */
  GRAPHICS_TEXT = 'GRAPHICS_TEXT',
  /** 视频 */
  VIDEO = 'VIDEO',
  /** 图文列表四 */
  MEDIA_CARD_LIST_FOUR = 'MEDIA_CARD_LIST_FOUR',
}

/**
 * 公告展示类型
 * @param data
 * @returns
 */

export enum SHOWTYPE  {
  /** 平铺 */
  TILE = 'tile',
  /** 滚动 */
  SCROLL = 'scroll',
}